import React, { useState, useEffect } from "react";
import {
  AiOutlineArrowRight,
  AiOutlineArrowUp,
  AiFillCaretRight,
} from "react-icons/ai";

const IndoGreenAccordion = ({ question, answer, description }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [show, setShow] = useState(false);

  return (
    <li className="accordion indo-green-accordion block active-block">
      <div className="acc-btn active" onClick={() => setShow(!show)}>
        <div className="icon-outer">
          {show ? <AiOutlineArrowRight /> : <AiOutlineArrowUp />}
        </div>
        <h3>{question}</h3>
      </div>

      {show && (
        <div className="acc-content current">
          {answer.map((item, index) => (
            <span key={index} className="acc-content-span">
              <AiFillCaretRight
                size={15}
                className="position-absolute mt-2"
                style={{ marginLeft: "60px" }}
              />
              <p style={{ paddingLeft: "80px", paddingRight: "80px" }}>
                {item.item}
              </p>
            </span>
          ))}

          {/* Show description if it's not empty */}
          {description && (
            <p style={{ paddingLeft: "80px", paddingRight: "80px", marginTop: "10px" }}>
              <em>{description}</em>
            </p>
          )}
        </div>
      )}
    </li>
  );
};

export default IndoGreenAccordion;
